var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncCer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.25V17.75L12.75 16.25L14.75 17.75V13.25M7.75 14.75H2.75C2.21957 14.75 1.71086 14.5393 1.33579 14.1642C0.960714 13.7891 0.75 13.2804 0.75 12.75V2.75C0.75 1.65 1.65 0.75 2.75 0.75H16.75C17.2804 0.75 17.7891 0.960714 18.1642 1.33579C18.5393 1.71086 18.75 2.21957 18.75 2.75V12.75C18.7496 13.1007 18.6571 13.4452 18.4815 13.7488C18.306 14.0525 18.0537 14.3046 17.75 14.48M3.75 4.75H15.75M3.75 7.75H6.75M3.75 10.75H5.75M15.75 10.75C15.75 12.4069 14.4069 13.75 12.75 13.75C11.0931 13.75 9.75 12.4069 9.75 10.75C9.75 9.09315 11.0931 7.75 12.75 7.75C14.4069 7.75 15.75 9.09315 15.75 10.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncCer);
export default __webpack_public_path__ + "static/media/icon_inc_cer.578f1b992049539bd663d3126d9e1d0e.svg";
export { ForwardRef as ReactComponent };